/**
 * Коды событий журнала инвентаризации — зеркало App\Enums\InventoryLogType.
 *
 * Формат кода: <сущность>.<событие в прошедшем времени>, kebab-case внутри сегмента.
 */
export default class InventoryLogType {
    static ITEM_CREATED = 'inventory-item.created';
    static ITEM_UPDATED = 'inventory-item.updated';
    static ITEM_DELETED = 'inventory-item.deleted';

    /**
     * Легаси: до введения держателей смена материально ответственного писалась этим кодом.
     * Новые события пишутся как ITEM_HOLDER_CHANGED, но накопленные записи остаются здесь,
     * поэтому лента обязана понимать оба.
     */
    static ITEM_RESPONSIBLE_CHANGED = 'inventory-item.responsible-changed';

    static ITEM_HOLDER_CHANGED = 'inventory-item.holder-changed';
    static ITEM_STATUS_CHANGED = 'inventory-item.status-changed';

    static ITEM_ATTRIBUTE_CREATED = 'inventory-item-attribute.created';
    static ITEM_ATTRIBUTE_UPDATED = 'inventory-item-attribute.updated';
    static ITEM_ATTRIBUTE_DELETED = 'inventory-item-attribute.deleted';

    static ITEM_FILE_ATTACHED = 'inventory-item-file.attached';
    static ITEM_FILE_DELETED = 'inventory-item-file.deleted';
    static ITEM_FILE_PRIMARY_SET = 'inventory-item-file.primary-set';
    static ITEM_FILE_PRIMARY_CLEARED = 'inventory-item-file.primary-cleared';
}
